<div class="cssload-container" [style.height]="size">
    <div class="cssload-speeding-wheel" [style.width]="size" [style.height]="size"></div>
</div>
